import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "waybill-details-modal__container" }
const _hoisted_2 = {
  key: 0,
  class: "container__state"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "state__message" }, "Загрузка данных...", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "state__message message--error" }, "При получении данных произошла ошибка", -1)
const _hoisted_5 = {
  key: 1,
  class: "container__content"
}
const _hoisted_6 = { class: "content__title" }
const _hoisted_7 = { class: "content__main" }
const _hoisted_8 = { class: "main__row" }
const _hoisted_9 = { class: "row__container" }
const _hoisted_10 = { class: "container__column" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "column__title" }, "Тип", -1)
const _hoisted_12 = { class: "column__value" }
const _hoisted_13 = { class: "container__column" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "column__title" }, "Дата", -1)
const _hoisted_15 = { class: "column__value" }
const _hoisted_16 = { class: "main__row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "9",
      cy: "7",
      r: "4"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M22 21v-2a4 4 0 0 0-3-3.87" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
  ]),
  /*#__PURE__*/_createTextVNode(" Экипаж и водитель ")
], -1)
const _hoisted_18 = { class: "row__container" }
const _hoisted_19 = { class: "container__column" }
const _hoisted_20 = { class: "column__title" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "9",
  cy: "7",
  r: "4"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("path", { d: "M22 21v-2a4 4 0 0 0-3-3.87" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" }, null, -1)
const _hoisted_25 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("path", { d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("path", { d: "M12 22V12" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("path", { d: "m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("path", { d: "m7.5 4.27 9 5.15" }, null, -1)
const _hoisted_30 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = { class: "column__value" }
const _hoisted_32 = { class: "container__column" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "column__title" }, "Водитель", -1)
const _hoisted_34 = { class: "column__value" }
const _hoisted_35 = {
  key: 0,
  class: "column__subtitle"
}
const _hoisted_36 = { class: "main__row" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M15 18H9" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "17",
      cy: "18",
      r: "2"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "7",
      cy: "18",
      r: "2"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Транспорт ")
], -1)
const _hoisted_38 = { class: "row__container" }
const _hoisted_39 = { class: "container__column" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "column__title" }, "Марка и модель", -1)
const _hoisted_41 = { class: "column__value" }
const _hoisted_42 = { class: "container__column" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "column__title" }, "Гос. номер", -1)
const _hoisted_44 = { class: "column__value" }
const _hoisted_45 = { class: "main__prices" }
const _hoisted_46 = { class: "prices__price" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "price__title" }, "Перевозка", -1)
const _hoisted_48 = { class: "price__amount" }
const _hoisted_49 = { class: "prices__price price--additional" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "price__title" }, "Доп. услуги", -1)
const _hoisted_51 = { class: "price__amount" }
const _hoisted_52 = { class: "prices__price price--total" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "price__title" }, "Итого", -1)
const _hoisted_54 = { class: "price__amount" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_loader = _resolveComponent("bs-loader")!
  const _component_bs_button = _resolveComponent("bs-button")!
  const _component_bs_status = _resolveComponent("bs-status")!
  const _component_bs_divider = _resolveComponent("bs-divider")!
  const _component_invoices = _resolveComponent("invoices")!
  const _component_bs_modal_scroll_container = _resolveComponent("bs-modal-scroll-container")!
  const _component_bs_modal = _resolveComponent("bs-modal")!

  return (_openBlock(), _createBlock(_component_bs_modal, {
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _ctx.onUpdateModelValue,
    onClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.state.isLoading || _ctx.state.isFailed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.state.isLoading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_3,
                    _createVNode(_component_bs_loader)
                  ], 64))
                : (_ctx.state.isFailed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_4,
                      _createVNode(_component_bs_button, {
                        color: "royal-blue",
                        onClick: _ctx.loadWaybillDetails
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Обновить")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : _createCommentVNode("", true)
            ]))
          : (_ctx.state.details)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, "Путевой лист " + _toDisplayString(_ctx.state.details.codeOneC), 1),
                _createVNode(_component_bs_modal_scroll_container, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _createElementVNode("div", _hoisted_12, [
                              (_ctx.state.details.waybillType)
                                ? (_openBlock(), _createBlock(_component_bs_status, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.state.details.waybillType), 1)
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" — ")
                                  ], 64))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("div", _hoisted_15, [
                              (_ctx.state.details.createdAt)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.state.details.createdAt)), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" — ")
                                  ], 64))
                            ])
                          ])
                        ])
                      ]),
                      _createVNode(_component_bs_divider, { horizontal: "" }),
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              (_ctx.state.details.forwarder)
                                ? (_openBlock(), _createElementBlock("svg", {
                                    key: 0,
                                    xmlns: "http://www.w3.org/2000/svg",
                                    style: _normalizeStyle({ color: 'var(--bs-color-royal-blue-500)' }),
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, _hoisted_25, 4))
                                : (_openBlock(), _createElementBlock("svg", {
                                    key: 1,
                                    xmlns: "http://www.w3.org/2000/svg",
                                    style: _normalizeStyle({ color: 'var(--bs-color-orange-500)' }),
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, _hoisted_30, 4)),
                              _createTextVNode(" Экипаж ")
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              (_ctx.state.details.forwarder)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.state.details.forwarder.fullName), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" Грузовой ")
                                  ], 64))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _hoisted_33,
                            _createElementVNode("div", _hoisted_34, [
                              (_ctx.state.details.courier)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.state.details.courier.fullName), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" — ")
                                  ], 64))
                            ]),
                            (_ctx.state.details.courier)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.state.details.courier.phoneNumber), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createVNode(_component_bs_divider, { horizontal: "" }),
                      _createElementVNode("div", _hoisted_36, [
                        _hoisted_37,
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _hoisted_40,
                            _createElementVNode("div", _hoisted_41, [
                              (_ctx.state.details.car)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.state.details.car.model), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" — ")
                                  ], 64))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _hoisted_43,
                            _createElementVNode("div", _hoisted_44, [
                              (_ctx.state.details.car)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.state.details.car.number), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" — ")
                                  ], 64))
                            ])
                          ])
                        ])
                      ]),
                      _createVNode(_component_bs_divider, { horizontal: "" }),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _hoisted_47,
                          _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.formatPriceToTenge(_ctx.state.details.ndsTotalAmount, { withDecimals: true }) || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _hoisted_50,
                          _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.formatPriceToTenge(_ctx.state.details.additionalServicesTotalAmount, { withDecimals: true }) || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _hoisted_53,
                          _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.formatPriceToTenge(_ctx.total, { withDecimals: true }) || '—'), 1)
                        ])
                      ]),
                      (_ctx.state.details.invoices.length > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_bs_divider, { horizontal: "" }),
                            _createVNode(_component_invoices, {
                              invoices: _ctx.state.details.invoices
                            }, null, 8, ["invoices"])
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue", "onClose"]))
}